export const getRoleBasedRedirectPath = (roleId) => {
  switch(roleId) {
    case 1:
      return '/panel/lms/ordersAdmin';
    case 2:
      return '/panel/lms/ordersAgent';
    case 3:
      return '/panel/lms/ordersTeamLeader';
    case 4:
      return '/panel/lms/leads';
    case 11:
      return '/panel/lms/leads';
    case 5:
      return '/panel/lms/utils/quick-links';
    case 6:
      return '/panel/lms/utils/quick-links';
    case 7:
      return '/panel/lms/ordersValidation';
    case 8:
      return '/panel/lms/products';
    case 9:
      return '/panel/lms/ordersAdmin';
    case 10:
      return '/panel/lms/utils/quick-links';
    default:
      return '/panel/lms/utils/quick-links';
  }
} 